import { z } from 'zod';

export const schemaConsorsSchufaInfoResponseEntry = z.object({
    duplicatedRequest: z.boolean().optional(),
    errorMessage: z.union([z.string(), z.record(z.any())]).optional(),
    identifier: z.string().optional(),
    referenceId: z.string(),
});

export type SchemaConsorsSchufaInfoResponseEntry = z.infer<typeof schemaConsorsSchufaInfoResponseEntry>;

export const schemaConsorsSchufaInfoResponse = z.object({
    identifiers: z.array(schemaConsorsSchufaInfoResponseEntry).min(1),
});

export type SchemaConsorsSchufaInfoResponse = z.infer<typeof schemaConsorsSchufaInfoResponse>;

export const schemaConsorsSchufaInfoBareResponse = z.object({
    identifiers: z.array(z.unknown()).min(1),
});

export type SchemaConsorsSchufaInfoBareResponse = z.infer<typeof schemaConsorsSchufaInfoBareResponse>;
